const options = {
  5: "bg-red-600/5",
  10: "bg-red-600/10",
  25: "bg-red-600/25",
  50: "bg-red-600/50",
  75: "bg-red-600/75",
  90: "bg-red-600/90",
  100: "bg-red-600",
};

const from = {
  5: "from-red-600/5",
  10: "from-red-600/10",
  25: "from-red-600/25",
  50: "from-red-600/50",
  75: "from-red-600/75",
  90: "from-red-600/90",
  100: "from-red-600",
};

export default function getBackgroundRed600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
